import { userPermission } from '@/constants';
import HubAdjustmentTestModeEntrace from '@/views/HubAdjustment/TestModeEntrance/index.vue';
import HubAdjustment from '@/views/HubAdjustment/index.vue';
import HubAdjustmentMain from '@/views/HubAdjustment/Main/index.vue';
import HubAdjustmentDailySales from '@/views/HubAdjustment/Daily/Sales/index.vue';
import HubAdjustmentDailySalesDetail from '@/views/HubAdjustment/Daily/SalesDetail/index.vue';
import HubAdjustmentDailyPurchase from '@/views/HubAdjustment/Daily/Purchase/index.vue';
import { pageAuthorization } from '@/router-middleware';
import { routeName } from '@/constants/routeName';
import basicOptions from '@/router/basic-options';
export default [
    {
        path: 'hub-adjustment',
        name: routeName.HUB_ADJUSTMENT,
        component: HubAdjustment,
        redirect: {
            name: routeName.HUB_ADJUSTMENT_MAIN,
        },
        children: [
            {
                path: 'main/:selectedMonth*',
                name: routeName.HUB_ADJUSTMENT_MAIN,
                component: HubAdjustmentMain,
                meta: {
                    ...basicOptions,
                    middleware: [
                        pageAuthorization([
                            userPermission.P_GET_HUB_SALES,
                        ]),
                        ...basicOptions.middleware,
                    ],
                },
            },
            {
                path: 'daily/:selectedMonth/sales/:type(b2b-delivery-charge|road-shop-delivery-charge|store-management-fee|store-fee|sales-order-distributor-hub-fee|hub-fee)',
                name: routeName.HUB_ADJUSTMENT_DAILY_SALES,
                component: HubAdjustmentDailySales,
                meta: {
                    ...basicOptions,
                    middleware: [
                        pageAuthorization([
                            userPermission.P_GET_HUB_SALES,
                        ]),
                        ...basicOptions.middleware,
                    ],
                },
            },
            {
                path: 'daily/:selectedMonth/sales/:type(b2b-delivery-charge|road-shop-delivery-charge|store-management-fee|store-fee|sales-order-distributor-hub-fee|hub-fee)/:date',
                name: routeName.HUB_ADJUSTMENT_DAILY_SALES_DETAIL,
                component: HubAdjustmentDailySalesDetail,
                meta: {
                    ...basicOptions,
                    middleware: [
                        pageAuthorization([
                            userPermission.P_GET_HUB_SALES,
                        ]),
                        ...basicOptions.middleware,
                    ],
                },
            },
            {
                path: 'daily/:selectedMonth/purchase/:type(hub-fee|store-management-fee)',
                name: routeName.HUB_ADJUSTMENT_DAILY_PURCHASE,
                component: HubAdjustmentDailyPurchase,
                meta: {
                    ...basicOptions,
                    middleware: [
                        pageAuthorization([
                            userPermission.P_GET_HUB_SALES,
                        ]),
                        ...basicOptions.middleware,
                    ],
                },
            },
        ],
    },
    {
        path: 'hub-adjustment-test-mode-entrance',
        name: routeName.HUB_ADJUSTMENT_TEST_MODE_ENTRANCE,
        component: HubAdjustmentTestModeEntrace,
        meta: {
            ...basicOptions,
            middleware: [
                pageAuthorization([
                    userPermission.P_GET_HUB_SALES,
                ]),
                ...basicOptions.middleware,
            ],
        },
    },
];
